import { merge } from "lodash-es"
import type HttpClient from "../../tastyworks/http"
import type { PaginationParams } from "../../tastyworks/request"
import {
  parseSingleResponse,
  type ItemsResponse,
  type SingleResponse,
} from "../../tastyworks/response"
import { JsonBuilder } from "../../tastyworks/util/json"
import { WITHDRAWAL_DESER, Withdrawal } from "../../tastyworks/withdrawal"
import {
  WITHDRAWAL_DRY_RUNNABLE_DESER,
  WITHDRAWAL_DRY_RUN_DESER,
  WithdrawalDryRun,
  type WithdrawalDryRunnable,
} from "../../tastyworks/withdrawal-dry-run"

const CASH_MANAGEMENT_API_VERSION = "20260429"
const CASH_MANAGEMENT_API_HEADERS: HeadersInit = {
  "Accept-Version": CASH_MANAGEMENT_API_VERSION,
}
export interface WithdrawalIndexParams extends PaginationParams {
  displayStablecoin?: boolean
}

export class WithdrawalService {
  constructor(private readonly accountNumberClient: HttpClient) {}

  readonly index = async (
    accountNumber: string,
    params?: WithdrawalIndexParams
  ): Promise<ItemsResponse<Withdrawal>> =>
    this.accountNumberClient.indexSimple(
      WITHDRAWAL_DESER.toParser(Withdrawal),
      "withdrawals",
      merge({ accountNumber }, params),
      CASH_MANAGEMENT_API_HEADERS
    )

  readonly create = async (
    withdrawal: Withdrawal
  ): Promise<SingleResponse<Withdrawal>> =>
    this.accountNumberClient.create(
      withdrawal,
      WITHDRAWAL_DESER.serialize,
      WITHDRAWAL_DESER.update,
      "withdrawals",
      {
        accountNumber: withdrawal.accountNumber,
      },
      CASH_MANAGEMENT_API_HEADERS
    )

  readonly dryRun = async (
    withdrawalDryRunnable: WithdrawalDryRunnable
  ): Promise<SingleResponse<WithdrawalDryRun>> => {
    const builder = new JsonBuilder()
    WITHDRAWAL_DRY_RUNNABLE_DESER.serialize(withdrawalDryRunnable, builder)
    const helper = await this.accountNumberClient.postJson(
      "withdrawals/dry-run",
      builder.json,
      { accountNumber: withdrawalDryRunnable.accountNumber },
      CASH_MANAGEMENT_API_HEADERS
    )

    return parseSingleResponse<WithdrawalDryRun>(
      helper,
      WITHDRAWAL_DRY_RUN_DESER.toParser(WithdrawalDryRun)
    )
  }
}
